import { Outlet } from "react-router-dom";

export default function Reports() {
  return <Outlet />;
}
